import { Link, useSearchParams } from "react-router-dom";
import { Seo } from "../lib/seo";
import { Eyebrow } from "../components/atoms";

// Landing page for the emailed partner confirmation link. The backend
// redirect here only happens after the single-use token is validated and the
// order flips to complimentary_confirmed.
export default function PartnerConfirmed() {
  const [params] = useSearchParams();
  const ref = params.get("ref");
  return (
    <>
      <Seo title="SuburbIQ confirmed | 80 Metrics" description="Your complimentary SuburbIQ report is confirmed." />
      <section className="bg-herowhite">
        <div className="max-w-3xl mx-auto px-6 lg:px-16 py-24 lg:py-32" data-testid="partner-confirmed-page">
          <Eyebrow>Complimentary SuburbIQ</Eyebrow>
          <h1 className="mt-4 font-serif text-4xl lg:text-5xl font-medium text-charcoal">Your report is confirmed</h1>
          {ref && (
            <p className="mt-6 text-base text-charcoal/70">
              Reference: <span className="font-semibold text-charcoal" data-testid="partner-confirmed-reference">{ref}</span>
            </p>
          )}
          <p className="mt-4 text-base leading-relaxed text-charcoal/70">
            Matthew prepares each SuburbIQ report personally — expect yours within 2 business days.
            If anything about your question changes in the meantime, just reply to your confirmation email.
          </p>
          <Link
            to="/"
            data-testid="partner-confirmed-home"
            className="mt-10 inline-block text-xs font-semibold tracking-[0.2em] uppercase text-charcoal/70 hover:text-golddark transition-colors duration-300"
          >
            ← Back to 80 Metrics
          </Link>
        </div>
      </section>
    </>
  );
}
